import { createSlice } from '@reduxjs/toolkit'

export const CustomerData = createSlice({
    name: 'customerData',
    initialState: {
        customerData: null,
    },
    reducers: {
        setCustomerData: (state, action) => { state.customerData = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setCustomerData } = CustomerData.actions

export default CustomerData.reducer